/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoiceBatchProcessCustomer: "invoice-batch-process-customer",
  invoiceBatchProcessShipper: "invoice-batch-process-shipper",
  invoiceBatchProcessReceiver: "invoice-batch-process-receiver",
  invoiceBatchProcessCondition: "invoice-batch-process-condition",
  invoiceBatchProcessStatus: "invoice-batch-process-status",
  invoiceBatchProcessCancel: "invoice-batch-process-cancel",
  invoiceBatchProcessConfirm: "invoice-batch-process-confirm",
} as const;
